import _ from 'lodash';
import moment from 'moment';
import 'moment/locale/th';
import 'moment/locale/ja';
import 'moment/locale/vi';

import { formatDate } from 'src/utils/Date';
import { HYPHEN_CHARACTER } from 'src/constants/Generals';
import { useTranslation } from "react-i18next"

const MONTHS_IN_YEAR = 12;
const QUARTERS_IN_YEAR = 4;

export const selectOptionMonths = Array(MONTHS_IN_YEAR)
  .fill()
  .map((_ignore, i) => ({
    value: i + 1,
    label: i + 1
  }));

export const getMonthOptions = language => {
  moment.locale(language);
  return Array(MONTHS_IN_YEAR)
    .fill()
    .map((_ignore, i) => {
      const label = moment(i + 1, 'M').format('MMMM');
      const capitalizedLabel = language === 'vi' && label ? label.charAt(0).toUpperCase() + label.slice(1) : label;
      return { value: i + 1, label: capitalizedLabel };
    });
};

export const getQuarterOptions = t =>
  Array(QUARTERS_IN_YEAR)
    .fill()
    .map((_ignore, i) => ({
      value: i + 1,
      label: t('features.ReportIncomeTax.create.quarter_option', { quarter: i + 1 })
    }));

export const fetchValueByIndexAndField = arrayValues => fieldName => index =>
  _.get(arrayValues, [index, fieldName], undefined);

export const getOptionLabel = value => options => {
  const option = options ? options.find(op => op.value === value) || {} : {};
  return option.label;
};

export const numToStr = num =>
  num &&
  _(`${num}`)
    .toArray()
    .reverse()
    .chunk(3)
    .reverse()
    .map(arr => arr.reverse().join(''))
    .join(',');

export const sumFloatNumber = (...numbers) => fixedPointLength =>
  numbers.reduce((sum, number) => sum + parseFloat(+number), 0.0).toFixed(fixedPointLength);

export const sumFloatNumberFixed5 = (...numbers) =>
  sumFloatNumber(...numbers)(5)
    .replace(/0+$/, '')
    .replace(/\.$/, '');

export const toFloatString = number => {
  if (number === parseInt(number, 10).toFixed()) return parseFloat(number).toFixed(1);
  return number;
};

export const isIncluded = (comparingValue, beComparedValue) =>
  typeof comparingValue === 'string' && comparingValue.indexOf(beComparedValue) >= 0;
export const isEqual = (comparingValue, beComparedValue) => comparingValue === beComparedValue;

export const concatArray = (array1, array2) => booleanFunc => {
  const additions = array2.filter(a2 => booleanFunc(array1, a2));
  return [...array1, ...additions];
};

export const isTimeOverNow = dateString => dateString > new Date().toISOString();

const selector = (state, ...keys) => _.get(state, keys);
export default selector;

export const arrayToObject = (defaultValue, toTargetArray) => {
  const copyDefault = {
    ...defaultValue
  };
  if (toTargetArray) {
    Object.keys(copyDefault).forEach(key => {
      if (!toTargetArray.includes(key)) {
        copyDefault[key] = false;
      }
    });
  }
  return copyDefault;
};

export const isArr1ContainArr2 = (arr1, arr2) => arr2.every(item => arr1.indexOf(item) !== -1);

export const deleteFromObjIfNotInRange = (obj, fieldToDelete, valueRange) => {
  const copyObj = {
    ...obj
  };
  const currentValue = (obj[fieldToDelete] || '').toString().split('_');
  const allValue = valueRange ? valueRange.map(item => item.value.toString()) : [];
  if (!isArr1ContainArr2(allValue, currentValue)) {
    delete copyObj[fieldToDelete];
  }
  return copyObj;
};

export const isInTargetDateRange = (targetStartDate, targetEndDate, compareDate) => {
  if (!targetStartDate || !targetEndDate || !compareDate) {
    return false;
  }
  return targetStartDate <= compareDate && compareDate <= targetEndDate;
};

export const toJpYear = date => {
  const dateMoment = moment(date);
  if (!dateMoment.isValid()) {
    return '';
  }
  const list = [
    ['1989-01-08', '平成'],
    ['1926-12-25', '昭和'],
    ['1912-07-30', '大正'],
    ['1868-01-25', '明治']
  ];
  let yearStr = null;
  const targetYearFormat = list.find(item => dateMoment.isSameOrAfter(item[0]));
  if (targetYearFormat) {
    const year = dateMoment.year() - moment(targetYearFormat[0]).year() + 1;
    yearStr = year === 1 ? `${targetYearFormat[1]}元年` : `${targetYearFormat[1]}${year}年`;
  }
  return yearStr ? dateMoment.format('LL').replace(/\d{4}年/, yearStr) : dateMoment.format('LL');
};

export const recordDisplay = text => text || HYPHEN_CHARACTER;
export const employeeDisplay = text => text || HYPHEN_CHARACTER;

employeeDisplay.fullName = (record, i18n) => {
  if (i18n.language === 'vi') {
    return `${record.lastName} ${record.firstName}`;
  }

  return `${record.firstName} ${record.lastName}`;
};
const replaceUndefinedWithBlank = (array) => {
  for (var i = 0; i < array.length; i++) {
    if (array[i] == undefined) {
      array.splice(i, 1, "");
    }
  }
}

employeeDisplay.address = (record) => {
  const { i18n } = useTranslation();
  if (!record) {
    return employeeDisplay();
  }

  // let array = [
  //   // record.postalCodePart0 && record.postalCodePart1 && `〒${record.postalCodePart0}-${record.postalCodePart1}\n`,
  //   // getOptionLabel(record.prefectureId)(prefectures),
  //   record.addressNumber,
  //   record.city,
  //   record.street,
  //   record.building,
  //    record.soi ? i18n.language === 'th' ? "ซอย " + record.soi : "Soi " + record.soi : "",
  //   i18n.language === 'th' ? record.employeeFullAddress.addressThai : record.employeeFullAddress.addressEng,
  //   record.postalCode
  // ]
  let array = []

  if (i18n.language === 'th') {
    array.push(record.houseNumber ? "เลขที่ " + record.houseNumber : "");
    array.push(record.building ? "อาคาร " + record.building : "");
    array.push(record.soi ? "ซอย " + record.soi : "");
    array.push(record.street ? "ถนน " + record.street : "");
    array.push(record.employeeFullAddress.addressThai);
    array.push(record.postalCode);
  }
  else {
    array.push(record.houseNumber ? record.houseNumber : "");
    array.push(record.building ? record.building + " Building," : "");
    array.push(record.soi ? "soi " + record.soi + "," : "");
    array.push(record.street ? record.street + " road," : "");
    array.push(record.employeeFullAddress.addressEng);
    array.push(record.postalCode);
  }

  // let array = [
  //     record.houseNumber,
  //     record.building,
  //     record.soi,
  //     record.street,
  //     record.employeeFullAddress.addressThai,
  //     record.postalCode
  // ]

  replaceUndefinedWithBlank(array);
  return (
    array
      .filter(str => str)
      .join(' ') || employeeDisplay()
  );
};

employeeDisplay.familyAddress = (record, prefectures) => {
  const {
    i18n
  } = useTranslation();
  if (!record) {
    return employeeDisplay();
  }

  let array = [
    // record.postalCodePart0 && record.postalCodePart1 && `〒${record.postalCodePart0}-${record.postalCodePart1}\n`,
    // getOptionLabel(record.prefectureId)(prefectures),
    record.addressNumber,
    record.city,
    record.street,
    record.building,
    record.soi ? i18n.language === 'th' ? "ซอย " + record.soi : "Soi " + record.soi : "",
    i18n.language === 'th' ? record.employeeFamilySupportFullAddress.addressThai : record.employeeFamilySupportFullAddress.addressEng,
    record.postalCode
  ]
  replaceUndefinedWithBlank(array);
  return (
    array
      .filter(str => str)
      .join(' ') || employeeDisplay()
  );
};

employeeDisplay.birthday = record => {
  const { i18n } = useTranslation();
  if (!record || !record.birthday) {
    return employeeDisplay();
  }
  return `${formatDate(record.birthday)} (${moment().diff(record.birthday, 'years')} ${i18n.t(
    'features.Employees.components.BasicInfoSectionShow.years_old'
  )})`;
};

export const getGroupFullPathName = (groups, groupId, joinChar = '->') => {
  const groupNames = [];
  let group = groups.find(item => item.value === groupId);
  const condition = id => item => item.value === id;

  while (group) {
    groupNames.unshift(group.label);
    group = groups.find(condition(group.parentDepartmentId));
  }

  return groupNames.join(joinChar);
};

export const toMoneyFormat = value => (value ? `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}vnd` : '0vnd');
export const numberWithComma = value => (value ? `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}` : value);
export const numberToTime = value => {
  if (value === undefined) return "0 Hr(s) 0 min"
  const arr = value.split(/[\.\:]/);
  return arr[0] + " Hr(s)" + (arr[1] !== "00" ? " " + arr[1] + " mins" : " 0 min")
}
export const decimalPlace2 = value => {

  if (typeof value === "string") {
    value = parseFloat(value);
  }

  return value ? value.toFixed(2).replace('.', ',') : value;
};

export const arrayToCheckBoxObject = arr => {
  const checkBoxObj = {};
  _.forEach(arr, item => {
    checkBoxObj[item.id] = true;
  });
  return checkBoxObj;
};
export const checkedTrueObjToArr = obj => {
  const result = [];
  _.forEach(obj, (value, key) => {
    if (value) {
      result.push(key);
    }
  });
  return result;
};
recordDisplay.dateOrTime = dateTime => {
  const { i18n } = useTranslation();
  if (i18n.language == 'th') {
    moment.locale('th')
  } else if (i18n.language == 'ja') {
    moment.locale('ja')
  } else {
    moment.locale('en')
  }

  if (!dateTime) {
    return recordDisplay();
  }
  if (moment().isSame(dateTime, 'day')) {
    return moment(dateTime).format('LT');
  }
  if (
    moment()
      .subtract(1, 'days')
      .isSame(dateTime, 'day')
  ) {
    // return 'Yesterday';
    return moment().subtract(1, 'days').calendar().split(" ")[0]
  }
  if (
    moment()
      .subtract(2, 'days')
      .isSame(dateTime, 'day')
  ) {
    // return '2 days ago';
    if (i18n.language == 'th') {
      return '2 วันที่แล้ว'
    } else if (i18n.language == 'ja') {
      return "2日前"
    } else {
      return "2 days ago"
    }
  }
  if (moment().isSame(dateTime, 'year')) {
    return moment(dateTime).format('MM/DD');
  }
  return moment(dateTime).format('L');
};

// param: dateTime
// result: "MM月DD日" (currentYear's time) other: "YYYY年MM月DD日"
recordDisplay.currentOrPrevYear = dateTime => {
  if (!dateTime) {
    return recordDisplay();
  }
  if (moment().isSame(dateTime, 'year')) {
    return moment(dateTime).format('MM/DD');
  }
  return moment(dateTime).format('L');
};

export const convertNumberToStrOfValueInArray = arr => arr.map(item => ({
  ...item,
  value: `${item.value}`
}));

export const convertArrayIntoJbcStyle = list => list.map(item => ({
  id: `${item.value}`,
  name: item.label
}));

export const convertArrayIntoJbcStyleNameLabelV = list =>
  list.map(item => ({
    name: `${item.value}`,
    label: item.label
  }));

export const display = (value, defaultIfBlank = HYPHEN_CHARACTER) => value || defaultIfBlank;

export const currency = (value, suffix = 'VND', defaultIfBlank = HYPHEN_CHARACTER) =>
  value && value !== HYPHEN_CHARACTER ? value + " " + suffix : defaultIfBlank;

export const scrollToTop = () => window.scrollTo(0, 0);

export const csrfToken = () => document.getElementsByName('csrf-token')[0].getAttribute('content');

export const replaceMessages = (originals, befores, afters) =>
  originals.map(value => {
    let afterValue = value;
    befores.forEach((str, index) => {
      if (afters[index] !== undefined) {
        afterValue = afterValue.replace(new RegExp(str, 'g'), afters[index]);
      }
    });
    return afterValue;
  });

export const citizenID = value => value.replace((/^(\d{1,1})\-?(\d{1,4})?\-?(\d{1,5})?\-?(\d{1,2})?\-?(\d{1})?$/), (result, data1, data2, data3, data4, data5) => {
  if (!value) return value
  else {
    return (
      (data1 || "") + (data2 !== undefined ? "-" : "") +
      (data2 || "") + (data3 !== undefined ? "-" : "") +
      (data3 || "") + (data4 !== undefined ? "-" : "") +
      (data4 || "") + (data5 !== undefined ? "-" : "") +
      (data5 || "")
    )
  }
})


export const isDateInPast = (thisDate, expectedDate) => {
  // check if {thisDate} is in the Past of {expectedDate} => return true if thisDate == expectedDate
  if (thisDate) {
    return moment(thisDate).isBefore(moment(expectedDate))
  }
  // will return true if thisDate is not set
  return true;

}
